module.exports = __webpack_public_path__ + "static/img/11.6a0609c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/8/zh/11.png
// module id = 8S1K
// module chunks = 0